__turbopack_context__.v({
  "bankInfo": "Footer-module-scss-module__VVBxPq__bankInfo",
  "bankInfoFeatures": "Footer-module-scss-module__VVBxPq__bankInfoFeatures",
  "bankInfoLogos": "Footer-module-scss-module__VVBxPq__bankInfoLogos",
  "clients": "Footer-module-scss-module__VVBxPq__clients",
  "company": "Footer-module-scss-module__VVBxPq__company",
  "contacts": "Footer-module-scss-module__VVBxPq__contacts",
  "container": "Footer-module-scss-module__VVBxPq__container",
  "content": "Footer-module-scss-module__VVBxPq__content",
  "dividerHorizontal": "Footer-module-scss-module__VVBxPq__dividerHorizontal",
  "help": "Footer-module-scss-module__VVBxPq__help",
  "logo": "Footer-module-scss-module__VVBxPq__logo",
  "socialIcons": "Footer-module-scss-module__VVBxPq__socialIcons",
  "socialQuestionBody": "Footer-module-scss-module__VVBxPq__socialQuestionBody",
  "socialQuestionHead": "Footer-module-scss-module__VVBxPq__socialQuestionHead",
  "socialQuestionHead2": "Footer-module-scss-module__VVBxPq__socialQuestionHead2",
});
